export default "__VITE_ASSET__CvWZQ40H__"